<template>
  <div class="section">
    <div class="title" v-html="title"></div>
    <div class="button"><el-link type="info" :underline="false" @click="buttonClick">{{buttonName}}</el-link></div>
  </div>
</template>

<script>
  export default {
    name: 'section-area',
    props: {
      title: String,
      buttonName: String
    },
    methods: {
      buttonClick() {
        this.$emit('buttonClick')
      }
    }
  }
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
  @import '../style/variables.scss';
  .section {
    height: 30px;
    margin: 0 0 10px 0;
    border-bottom: 1px solid #d2d2d2;
    display: flex;
    align-items: center;
    text-align: right;
  }

  .title {
    color: $theme-yellow;
    font-size: 24px;
    font-weight: bold;
    /*flex: 1;*/
    width: 100px;
    margin-left: 15px;
    text-align: justify;
    text-align-last: justify;
    text-justify: distribute;
  }

  .button {
    flex: 1;
  }
</style>



// WEBPACK FOOTER //
// src/components/section-area.vue